import classNames from 'classnames'
import React, { FC } from 'react'

import { UspIcon } from '~/assets/icons'
import UspBadge from '~/components/usp-badge'

import CountdownBadge from './countdown-badge'
import styles from './styles.module.css'

interface ExtensionProps {
  isExclusive: boolean
  isSponsored: boolean
  isEndingSoon: boolean
  endDate: Date | null
  isMobileView: boolean
  criticalJs: boolean
  isBlackFriday?: boolean
  hasBlackFridayPromotion?: boolean
  isTenancyUpdate?: boolean
}

const ExclusiveBadge = ({ isExclusive, isBlackFriday }: { isExclusive: boolean; isBlackFriday: boolean }) => {
  if (!isExclusive && !isBlackFriday) return null

  if (!isExclusive)
    return (
      <UspBadge
        className={styles.exclusive}
        icon={<UspIcon className={`usps ${styles.icon}`} promotionType='black-friday' />}
        text='Black Friday deal'
        variant='black-primary'
      />
    )

  if (!isBlackFriday) return <UspBadge className={styles.exclusive} text='Uswitch Exclusive' variant='black-primary' />

  return (
    <UspBadge
      className={styles.exclusive}
      icon={<UspIcon className={`usps ${styles.icon}`} promotionType='black-friday' />}
      text='Uswitch Black Friday Exclusive'
      variant='black-primary'
    />
  )
}

const Extension: FC<ExtensionProps> = ({
  isExclusive,
  isSponsored,
  isEndingSoon,
  endDate,
  isMobileView,
  criticalJs,
  isBlackFriday = false,
  hasBlackFridayPromotion = false,
  isTenancyUpdate = false
}) => (
  <div
    className={classNames(styles.container, {
      [styles.isTenancyUpdate]: isTenancyUpdate,
      [styles.isBlackFriday]: isBlackFriday,
      [styles.hasCountdown]: isEndingSoon && endDate,
      [styles.isMobileView]: isMobileView,
      [styles.isExclusive]: isExclusive,
      [styles.isSponsored]: isSponsored
    })}
  >
    <ExclusiveBadge isExclusive={isExclusive} isBlackFriday={hasBlackFridayPromotion} />

    {isSponsored && (
      <span
        className={classNames(styles.sponsored, {
          [styles.blackFriday]: isBlackFriday
        })}
      >
        Sponsored
      </span>
    )}

    {isEndingSoon && endDate && (
      <span className={styles.countdownContainer}>
        <CountdownBadge endDate={endDate} criticalJs={criticalJs} />
      </span>
    )}
  </div>
)

export default Extension
